import { Injectable } from '@angular/core';
import { Action, createSelector, Selector, State, StateContext, StateToken, Store } from '@ngxs/store';
import { ResetCompanyForm } from '@stores/company-form/company-form.actions';
import { Logout, SetItem } from '@stores/secure/secure.actions';

type SecureType = Record<string, string>;
const SecureStateToken = new StateToken<SecureType>('secure');

@State({ name: SecureStateToken, defaults: {} })
@Injectable()
export class SecureState {
  static LOCAL_MISSION_TOKEN = 'token';
  static LOCAL_MISSION_EVENT_ID = 'event-id';
  static COMPANY_TOKEN = 'company-token';
  static COMPANY_ID = 'company-id';
  static SECURE_SPACE_VISITED = 'secure-space-visited';

  static item(key: string): (state: SecureType) => string {
    return createSelector([SecureStateToken], (state: SecureType) => state[key]);
  }

  @Selector([SecureState])
  static companyToken(state: SecureType): string {
    return state[SecureState.COMPANY_TOKEN];
  }

  @Selector([SecureState])
  static companyId(state: SecureType): string {
    return state[SecureState.COMPANY_ID];
  }

  @Selector([SecureState])
  static secureSpaceVisited(state: SecureType): string {
    return state[SecureState.SECURE_SPACE_VISITED];
  }
  constructor(private readonly store: Store) {}

  @Action(SetItem)
  setConsent(ctx: StateContext<SecureType>, { key, value }: SetItem): void {
    ctx.patchState({ [key]: value });
  }

  @Action(Logout)
  logout(ctx: StateContext<SecureType>): void {
    this.store.dispatch(new ResetCompanyForm());
    ctx.setState({});
  }
}
